import { Flex } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface PageContentProps {
  children: ReactNode;
  overflow?: 'auto' | 'hidden' | 'visible';
}

const PageContent = ({ children, overflow = 'auto' }: PageContentProps) => {
  return (
    <Flex
      flex="1"
      direction="column"
      p="48px"
      overflow={overflow}
    >
      {children}
    </Flex>
  );
};

export default PageContent;
